import { useQuery } from "@apollo/client/react";
import GET_CLIENT_MONITORING_EVENTS from "../../queries/aml/getClientMointoringEvents";
import type { MonitorEventsResponse } from "../../../models/AmlMonitoringEvents";

type ClientMonitoringEventsQueryResponse = {
  client: {
    monitoringEvents: MonitorEventsResponse;
  };
};

export const useClientMonitoringEvents = (
  id: string,
  isHandled?: boolean,
  skip?: number,
  take?: number
) => {
  const { data, error, loading, refetch } =
    useQuery<ClientMonitoringEventsQueryResponse>(
      GET_CLIENT_MONITORING_EVENTS,
      {
        variables: {
          identifier: id,
          isHandled: isHandled,
          skip: skip,
          take: take,
        },
        fetchPolicy: "no-cache",
      }
    );

  return { clientMonitoringEvents: data?.client, error, loading, refetch };
};
